import { SearchFirmwareResponse } from '../../core/openapi/bff-admin-api';
import { IEquipmentModel, IFirmwareItem } from './firmwares.model';

export class FirmwaresMapper {
  public static mapFromDto(apiItem: SearchFirmwareResponse): IFirmwareItem {
    return {
      id: apiItem.id,
      name: apiItem.name,
      version: apiItem.version,
      comment: apiItem.comment || undefined,
      originFileName: apiItem.originFileName,
      equipmentModels: apiItem.equipmentModels.map(
        (equipmentModel): IEquipmentModel => ({
          id: equipmentModel.id,
          name: equipmentModel.name,
        }),
      ),
      createdBy: apiItem.createdBy,
      createdByName: apiItem.createdByName,
      createdDate: apiItem.createdDate,
    };
  }
}
